<template>
  <div class="wrap-poi-info">
    <!-- 竖屏时 -->
    <div v-if="$store.state.app.isPortrait">
      <div class="close-icon" @click="$emit('close')"><span class="el-icon-close"></span></div>
      <div class="wrap-header">
        <div class="nav-back" @click="backFn">
          <i class="el-icon-arrow-left"></i>
        </div>
        地点详情
      </div>
      <div class="wrap-in">
        <!-- poi信息 -->
        <div class="poiInfo">
          <div class="name">{{ poi.name || '已选择的位置' }}</div>
          <div class="location">{{ buildInfo.buildName }} <span style="color:#fdf13a;">{{ floorMapping[poi.floor] }}</span> </div>
          <div class="close-location" @click="gotoHere">去这里</div>
        </div>
        <div class="ercodeqrcode2-block">
          <div class="">
            <el-image
              class="img"
              v-if="curPoiQRcode"
              :src="curPoiQRcode"
              :preview-src-list="[curPoiQRcode]"
              @click="handleClickItem"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="info">
            <div class="text1">扫码带你去</div>
            <div class="text2">{{ poi.name || '已选择的位置' }}</div>
          </div>
          <div class="text3">提示：使用时请开启手机蓝牙</div>
        </div>
      </div>
    </div>
    <!-- 横屏时 -->
    <div v-else>
      <div class="wrap-in">
        <!-- poi信息 -->
        <div class="poiInfo">
          <div class="name">{{ poi.name || '已选择的位置' }}</div>
          <div class="location">{{ buildInfo.buildName }} <span style="color:#fdf13a;">{{ floorMapping[poi.floor] }}</span> </div>
        </div>
  
        <div class="remark">{{ poi.itemRemark }}</div>
        <swiper v-show="imglist.length > 0" id="mySwiper" ref="mySwiper" :options="swiperOption">
          <!--必须的组件-->
          <!--每页幻灯片使用swiper-slide标签-->
          <!--幻灯片组件生成的标签自带.swiper-slide的类名，但单类名选择器设置的部分css(如宽高)将被覆盖-->
          <swiper-slide v-for="item in imglist" :key="item" class="swiper_slide_item">
            <el-image
              style="height: 100%"
              :src="qiniuBaseUrl + item"
              fit="contain"
              :preview-src-list="[qiniuBaseUrl + item]"
            >
              <div slot="placeholder" class="image-slot">
                加载中<span class="el-icon-loading"></span>
              </div>
            </el-image>
          </swiper-slide>
          <!-- 可选的控件 -->
          <!--分页器-->
          <div slot="pagination" class="swiper-pagination"></div>
          <!--前进后退按钮-->
          <div slot="button-prev" class="swiper-button-prev">
            <span class="el-icon-arrow-left"></span>
          </div>
          <div slot="button-next" class="swiper-button-next">
            <span class="el-icon-arrow-right"></span>
          </div>
        </swiper>
  
        <!-- 去这里 -->
        <div class="gotoHere" @click="gotoHere">
          <img class="nav-icon" src="/images/preloader/icon-1.png" alt="">
          <span>去这里</span>
        </div>
  
        <template v-if="imglist.length === 0">
          <!-- poi二维码 -->
          <div class="qrcode">
            <el-image
              class="img"
              v-if="curPoiQRcode"
              :src="curPoiQRcode"
              :preview-src-list="[curPoiQRcode]"
              @click="handleClickItem"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="info">
              <div class="text1">扫码带你去</div>
              <div class="text2">{{ poi.name || '已选择的位置' }}</div>
              <div class="text3">提示：使用时请开启手机蓝牙</div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- poi二维码 -->
          <div class="qrcode2">
            <el-image
              class="img"
              v-if="curPoiQRcode"
              :src="curPoiQRcode"
              :preview-src-list="[curPoiQRcode]"
              @click="handleClickItem"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="info">
              <div class="text1">扫码带你去</div>
              <div class="text2">{{ poi.name || '已选择的位置' }}</div>
              <div class="text3">提示：使用时请开启手机蓝牙</div>
            </div>
          </div>
        </template>
        <div class="box-btn">
          <!-- 后退按钮 -->
          <img class="btn-houtui" src="/images/preloader/but_huotui.png" alt="" @click="returnHandle">
          <!-- 关闭按钮 -->
          <img class="btn-close" src="/images/preloader/btn-close.png" alt="" @click="$emit('close')">
        </div>
      </div>
    </div>
    <div class="qrcodeImg" style="display: none;" ref="qrCodeUrl"></div>
  </div>
</template>

<script>
import { getLocalStorage } from '@/utils/auth'
import QRCode from 'qrcodejs2'
export default {
  components: {
  },
  props: {

  },
  data () {
    return {
      text: '',
      poi: {
        name: '内科',
        floor: 2
      },
      fromModule: null,
      swiperOption: {
        // 分页器配置项
        pagination: {
          el: '.swiper-pagination', // 分页器的类名
          clickable: true, // 点击分页器跳切换到相应的幻灯片
          type: 'bullets', // 小圆点|进度条|数字页码
          dynamicBullets: true, // 动态小圆点(type:'bullets'时)
          // 自定义分页器，需设置样式
          renderBullet (index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">${index + 1}</span>`
          }
        },
        // 前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 幻灯片播放配置项
        loop: true, // 是否循环播放
        speed: 1000, // 发生页面切换动画时，动画的切换速度
        autoplay: {
          delay: 5000, // 幻灯片停留时间
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          stopOnLastSlide: true // 切换到最后一个slide时是否停止自动切换。（loop模式下无效）。
        },
        on: {
          slideChangeTransitionEnd: function () {
            console.log(this.activeIndex); // 每次切换结束时，在控制台打印现在是第几个slide
          }
        }
      }
    };
  },
  computed: {
    // 大屏配置信息
    baseSettingInfo () {
      return this.$store.state.app.baseSettingInfo;
    },
    IS_DEV () {
      return this.$store.state.app.IS_DEV;
    },
    // 起点
    startPoint: {
      get () { return this.$store.state.nav.startPoint; },
      set (val) { this.$store.commit('nav/set_startPoint', val); }
    },
    envCode () {
      return getLocalStorage('envCode') ? getLocalStorage('envCode') : '0'
    },
    // appid
    appid () {
      return this.$store.state.app.appid;
    },
    imglist () {
      let arr = [];
      if (this.poi.images) {
        arr = JSON.parse(this.poi.images)
      }
      return arr;
    },
    // 七牛图片地址
    qiniuBaseUrl () {
      return this.$store.state.app.qiniuBaseUrl;
    },
    // 建筑信息
    buildInfo: {
      get () { return this.$store.state.nav.buildInfo; },
      set (val) { this.$store.commit('nav/set_buildInfo', val); }
    },
    // 地图楼层映射
    floorMapping () {
      return this.$store.getters['nav/floorMapping'];
    },
    // 地图当前聚焦楼层
    mapFocusFloor: {
      get () { return this.$store.state.nav.mapFocusFloor; },
      set (val) { this.$store.commit('nav/set_mapFocusFloor', val); }
    },
    // 当前选中的POI二维码
    curPoiQRcode: {
      get () { return this.$store.state.nav.curPoiQRcode; },
      set (val) { this.$store.commit('nav/set_curPoiQRcode', val); }
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    creatQrCode (ref) {
      if (ref) {
        ref.innerHTML = '';
        new QRCode(ref, {
          text: this.text, // 转换为二维码的内容
          width: 500,
          height: 500,
          colorDark: '#00423c',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      }
      return
    },
    // 竖屏后退操作
    backFn () {
      // this.$emit('close')
      // this.$emit('return', this.poi, this.fromModule);
      this.$emit('return', this.fromModule);
    },
    async init (data, fromModule) {
      console.log('poi信息：', data);
      console.log('来自模块：', fromModule);
      this.poi = data;
      this.fromModule = fromModule;
      let obj = { mpbt: this.buildInfo.buildType };
      if (Number(this.envCode) > 0) {
        obj.e = this.envCode
      }
      let params = this.$utils.urlEncode(obj, false);
      const res = await this.getAppQrcode();
      if (res && res.code === 0) {
        this.text = `${process.env.VUE_APP_QRCODE_URL}?${params}&id=${JSON.parse(res.data).id}`;
        await this.creatQrCode(this.$refs.qrCodeUrl);
        setTimeout(() => {
            this.curPoiQRcode = this.$refs.qrCodeUrl.children[0].toDataURL('image/png')
        }, 10);
      }
    },
    // 关闭el-image遮罩层
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 获取二维码
    async getAppQrcode () {
      let params = { 'buildId': this.buildInfo.buildId, 'n': this.poi['poiId'] }
      if (this.baseSettingInfo.basiSetting?.codeType === 1) {
        params.screen = this.$store.state.app.deviInfo.mac
      }
      try {
        let res = await this.$apis.third.getQcodeMapParamId({
          params: JSON.stringify(params)
        });
        console.log('res', res)
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    // 后退操作
    returnHandle () {
      this.$emit('close');
      this.$emit('return', this.fromModule);
    },
    // 去这里
    gotoHere () {
      // let point = poiData;
      // point.beaconId = point.id;
      // point.poiName = point.name;
      // point.axisX = point.x;
      // point.axisY = point.y;
      this.$emit('selectPoint', this.poi, this.fromModule);
    }
  }
};
</script>

<style scoped lang="scss">
@media (orientation: landscape) {
.wrap-poi-info {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url("/images/preloader/rect2.png") no-repeat;
  background-size: 100% 100%;
  padding: 30px 20px 30px 33px;
  box-sizing: border-box;
  .wrap-in {
    height: 100%;
    overflow: auto;
  }
  .poiInfo{
    padding: 28px 0 30px 0;
    .name{
      font-size: 24px;
      color: #21feaf;
    }
    .location{
      font-size: 20px;
      color: $color-white;
      padding: 25px 0 0 0;
    }
  }
  .remark {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    line-height: 24px;
  }
  .carousel {
    height: 258px;
  }
  .gotoHere{
    width: 100%;
    height: 58px;
    margin-top: 30px;
    color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('/images/preloader/button_default_01.png') no-repeat;
    background-size: 100% 100%;
    font-size: 18px;
    box-sizing: border-box;
    span{
      margin: 0 0 0 10px;
    }
    .nav-icon {
      width: 20px;
      height: 20px;
    }
  }
  .qrcode {
    height: auto;
    padding: 15px;
    margin: 25px 0 0 0;
    box-sizing: border-box;
    display: flex;
    border: 1px solid #5480a7;
    border-radius: 20px;
    align-items: center;
    ::v-deep .el-icon-circle-close {
      color: #fff;
    }
    .img {
      width: 120px;
      border-radius: 10px;
      margin: 0 20px 0 0;
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .text1 {
        font-size: 14px;
        color: $color-white;
      }
      .text2 {
        font-size: 20px;
        color: $color-white;
        margin: 15px 0 20px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        display: -webkit-box;
      }
      .text3 {
        font-size: 14px;
        color: #ff2828;
      }
    }
  }
  .qrcode2 {
    height: auto;
    padding: 15px;
    margin: 30px 0 0 0;
    box-sizing: border-box;
    display: flex;
    border: 1px solid #5480a7;
    border-radius: 20px;
    align-items: center;
    .img {
      width: 120px;
      height: 120px;
      border-radius: 20px;
    margin: 0 20px 0 0;
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .text1 {
        font-size: 14px;
        color: $color-white;
      }
      .text2 {
        font-size: 20px;
        color: $color-white;
        margin: 15px 0 20px 0;
      }
      .text3 {
        font-size: 14px;
        color: #ff2828;
      }
    }
  }
  .box-btn {
    position: relative;
    width: 100%;
    height: 48px;
    margin-top: 30px;
    // bottom: 0;
  }
  .btn-houtui{
    position: absolute;
    bottom: 0px;
    left: 30px;
    width: 120px;
  }
  .btn-close {
    position: absolute;
    bottom: 0px;
    right: 17px;
    width: 120px;
  }
  ::v-deep .el-carousel__button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  #mySwiper{
    margin-top: 30px;
    width: 100%;
    height: 258px;
    border-radius: 8px;
    ::v-deep .swiper-pagination-bullet-custom.swiper-pagination-bullet{
      width: 10px !important;
      height: 10px !important;
      background: #fff;
    }
    ::v-deep .swiper-button-prev, ::v-deep .swiper-button-next {
      background: rgba(0,0,0,0.5);
      width: 28px;
      height: 66px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after{
        color: #fff;
        font-size: 30px;
        position: static;
        display: none;
      }
      outline: none;
      span {
        font-size: 30px;
        color: #fff;
        outline: none;
      }
    }
  }
  .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .btn-box {
    position: absolute;
    bottom: 36px;
    width: 84%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

@media screen and (max-width: 1446px) {
  .wrap-poi-info {
    .qrcode {
      height: auto;
      padding: 10px;
      margin: 25px 0 0 0;
      box-sizing: border-box;
      display: flex;
      border: 1px solid #5480a7;
      border-radius: 20px;
      align-items: center;
      .img {
        width: 180px;
        border-radius: 5px;
        margin: 0 20px 0 0;
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        .text1 {
          font-size: 14px;
          color: $color-white;
        }
        .text2 {
          font-size: 20px;
          color: $color-white;
          margin: 15px 0 20px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }
        .text3 {
          font-size: 14px;
          color: #ff2828;
        }
      }
    }
    .qrcode2 {
      height: 168px;
      padding: 15px;
      margin: 30px 0 0 0;
      box-sizing: border-box;
      display: flex;
      border: 1px solid #5480a7;
      border-radius: 20px;
      align-items: center;
      .img {
        width: 120px;
        height: 120px;
        border-radius: 20px;
      margin: 0 20px 0 0;
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
        .text1 {
          font-size: 14px;
          color: $color-white;
        }
        .text2 {
          font-size: 20px;
          color: $color-white;
          margin: 15px 0 20px 0;
        }
        .text3 {
          font-size: 14px;
          color: #ff2828;
        }
      }
    }
  }
}
}

@media (orientation: portrait) {
  .wrap-header{
    position:relative;
    height:180px;
    font-size:64px;
    color:#fff;
    font-weight:600;
  }
  .nav-back{
    position:absolute;
    left:0;
    top:0;
  }
.wrap-poi-info {
  position: relative;
  .close-icon {
    display: block;
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 38px;
    color: #ccc;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border-radius: 50%;
    border: 2px solid #ccc;
    padding: 0;
    font-weight: bold;
    box-sizing: border-box;
  }
  width: 100%;
  overflow: hidden;
  // background: url("/images/preloader/rect2.png") no-repeat;
  // background: linear-gradient(-30deg,rgb(50,80,150) 0%, rgb(80,150,180) 100%);
  background: rgba(0,0,0,.2);
  border-radius: 12px;
  background-size: 100% 100%;
  padding:58px;
  box-sizing: border-box;
  .wrap-in {
    width: 100%;
    height: calc( 100% - 180px);
    display: flex;
    text-align: left;
  }
  .poiInfo{
    position:relative;
    width: 50%;
    margin-right:4%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 44px;
    box-sizing: border-box;
    border-radius: 28px;
    .name{
      font-size: 54px;
      color: #21feaf;
      margin-bottom: 24px;
    }
    .location{
      font-size: 44px;
      color: $color-white;
    }
    .close-location{
      width:80%;
      text-align:center;
      display:inline-block;
      // border:1px solid #fff;
      position:absolute;
      bottom:44px;
      left:50%;
      transform:translateX(-50%);
      font-size: 44px;
      color: $color-white;
      height:114px;
      line-height:114px;
      border-radius:60px;
      background:rgb(30,204,138)
    }
  }
  .ercode-block{
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 44px;
    box-sizing: border-box;
    border-radius: 28px;
    position: relative;
    flex: 1;
    display: flex;
    .img{
      width: 284px;
    }
  }
  .info{
    font-size:46px;
    color: #fff;
    padding-left: 44px;
    padding-top: 44px;
    line-height: 80px;
  }
  .text3{
    position: absolute;
    color: red;
    font-size: 46px;
    bottom: 43px;
    left: 43px;
  }
  .text1 {
    font-size: 2.41vw;
  }
  .text2 {
    font-size: 2.78vw;
  }
  .text3 {
    font-size: 2.04vw;
  }
}
}

</style>
